import React from 'react'
import { Footer as FooterSuite } from 'rsuite'
import tenantConfig from 'config/tenant'
import './footer.scss'

const Footer: React.FC = () => {
  return (
    <FooterSuite className="footer">
      <div className="footer__center">
        <p>
          {tenantConfig.name}
          {tenantConfig.poweredBy
            ? ` powered by ${tenantConfig.poweredBy.name}`
            : ''}
        </p>
      </div>
    </FooterSuite>
  )
}

export default Footer
